import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Errors, LocalService, StoreService, ManagerService } from '../core';
import { Subscription } from 'rxjs';
import { NavItem, MainNavConfig } from '../shared/ui/main-navigation/main-navigation.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {

  userProfile: any;
  errors: Errors = { errors: {} };
  isSalesChallenge: Boolean = false;
  isActivityChallenge: Boolean = false;
  isChallengePreference: Boolean = false;
  switchRole: any;
  retainUser!: Subscription;
  isAdmin: Boolean = false;
  isActivityChallengeUser: Boolean = false;
  isSalesChallengeUser: Boolean = false;
  userActivatedSubscription!: Subscription;
  isCiscoAdmin = false;
  mainNavConfig: MainNavConfig = { items: [] };

  constructor(
    private router: Router,
    private storeService: StoreService,
    private managerService: ManagerService
  ) { }

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');

    if (this.userProfile == null) {
      return this.router.navigateByUrl('/blocked');
    }

    this.findPendingRoles();

    const savedRole = localStorage.getItem('selectedRole');
    if (savedRole) {
      this.switchRole = savedRole;
    }
    this.buildNavConfig();

    this.userActivatedSubscription = this.storeService.userActivated.subscribe((role: any) => {
      this.switchRole = role;
      localStorage.setItem('selectedRole', this.switchRole);
      if (this.userProfile.hasOwnProperty('userType') && this.userProfile.userType === 'PAM') {
        if (this.switchRole === 'seller') {
          this.switchRole = 'manager';
        }
      }
      localStorage.removeItem('setSelectedChallengename');
      this.userProfile = LocalService.get('userProfile');
      this.buildNavConfig();
    });

    this.storeService.unsubscribeRoute.subscribe((flag: any) => {
      if (flag) {
        this.retainUser.unsubscribe();
      }
    });

    this.storeService.isTabActivated.subscribe((flag: any) => {
      if (flag) {
        this.getCompanyPreferences();
        this.getUserPreferences(6);
        this.getUserPreferences(7);
      }
    });

    if (this.userProfile.active) {
      this.getCompanyPreferences();
      this.getUserPreferences(6);
      this.getUserPreferences(7);
      this.setRole();
      this.retainUser = this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.setRole();
          if (this.router.url === '/home') {
            if (this.switchRole === 'manager') {
              return this.router.navigateByUrl('/home/manager');
            } else if (this.switchRole === 'seller') {
              return this.router.navigateByUrl('/home/seller');
            }
          }
        }
      });
    } else {
      this.storeService.userActivated.next('home');
    }

    if (this.userProfile.roles.find((item: any) => item.name === 'CISCO_ADMIN')) {
      if (this.userProfile.createSalesChg) {
        this.isCiscoAdmin = true;
      }
    }

    this.storeService.getIsciscoAdminFlag().subscribe((data: any) => {
      if (data != null) {
        const profile = LocalService.get('userProfile');
        const hasAdminRole = profile && profile.roles && profile.roles.find((item: any) => item.name === 'CISCO_ADMIN');
        this.isCiscoAdmin = data.isCiscoAdmin === true || Boolean(hasAdminRole && profile.createSalesChg);
        this.buildNavConfig();
      }
    });

    if (this.router.url === '/home/manageCashPayment') {
      this.switchRole = 'manager';
      this.storeService.userActivated.next('manager');
    }
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    if (this.userActivatedSubscription) {
      this.userActivatedSubscription.unsubscribe();
    }
  }

  findPendingRoles() {
    const admin = 'COMPANY_ADMIN';
    this.isAdmin = this.userProfile.hasOwnProperty('userType') ? true : this.userProfile.roles.find((item: any) => item.name === admin);
  }

  setRole() {
    const currentRoute = this.router.url;
    if (currentRoute.includes('manager')) {
      this.storeService.userActivated.next('manager');
    }
    if (currentRoute.includes('seller')) {
      this.storeService.userActivated.next('seller');
    }
  }

  getCompanyPreferences() {
    if (this.userProfile.company && this.userProfile.company.id) {
      const companyParams = {
        companyId: this.userProfile.company.id
      };
      this.managerService.getCompanyPreferences(companyParams).subscribe((data: any) => {
        const preferences = data.companyPreferences.map((item: any) => item.enabled);
        this.isSalesChallenge = preferences[0];
        this.isActivityChallenge = preferences[1];
        const preference = data.companyPreferences.find((item: any) => item.name === 'COMPANY_SALES_CHALLENGES_AND_REWARDS');
        if (preference) {
          this.isChallengePreference = preference.enabled;
        }
        this.buildNavConfig();
      }, (err: any) => {
        this.errors = err;
      });
    }
  }

  buildNavConfig() {
    if (!this.userProfile || !this.userProfile.active || !this.userProfile.company || !this.userProfile.company.profileComplete) {
      this.mainNavConfig = { items: [] };
      return;
    }

    const isPAM = this.userProfile.hasOwnProperty('userType') && this.userProfile.userType === 'PAM';
    const items: NavItem[] = [];

    if (this.switchRole === 'manager') {
      items.push({ label: 'home.viewChallenges', routerLink: '/home/manager/manage-challenges', icon: 'trophy' });

      if (this.isCiscoAdmin) {
        items.push({ label: 'home.manageCashPayment', routerLink: '/home/manageCashPayment', icon: 'payments', exactMatch: true });
      } else {
        items.push({ label: 'home.viewDashboard', routerLink: '/home/dashboard', icon: 'dashboard', exactMatch: true });
        if (this.isAdmin) {
          items.push({ label: 'home.manageClaims', routerLink: '/home/manager/admin-manage-claims', icon: 'description' });
        }
        if (isPAM) {
          items.push({ label: 'header.redeemRewards', routerLink: '/home/seller/redeem-rewards', icon: 'card_giftcard' });
        }
        items.push({ label: 'home.account', routerLink: '/home/manager/account-details', icon: 'bar_chart' });
        items.push({ label: 'home.viewLeaderboards', routerLink: '/home/manager/leaderboards', icon: 'leaderboard' });
        items.push({ label: 'footer.support', routerLink: '/support', icon: 'help_outline' });
      }

      this.mainNavConfig = { items, adminOffset: this.isCiscoAdmin };
      return;
    }

    if (this.switchRole === 'seller') {
      if (isPAM) {
        items.push({ label: 'home.iconHolder1', routerLink: '/home/manager/manage-challenges', icon: 'trophy' });
      }
      const canSeeChallenges =
        (this.isActivityChallenge && this.isActivityChallengeUser) ||
        (this.isSalesChallenge && this.isSalesChallengeUser && this.isChallengePreference);
      if (!isPAM && canSeeChallenges) {
        items.push({ label: 'home.iconHolder5', routerLink: '/home/seller/challenges', icon: 'extension' });
      }

      items.push({ label: 'home.viewDashboard', routerLink: '/home/dashboard', icon: 'dashboard', exactMatch: true });

      const claimsRoute = isPAM ? '/home/manager/admin-manage-claims' : '/home/seller/manage-claims';
      items.push({ label: 'home.manageClaims', routerLink: claimsRoute, icon: 'description' });
      items.push({ label: 'header.redeemRewards', routerLink: '/home/seller/redeem-rewards', icon: 'card_giftcard' });

      if (isPAM) {
        items.push({ label: 'home.account', routerLink: '/home/manager/account-details', icon: 'bar_chart' });
      }

      const leaderboardRoute = isPAM ? '/home/manager/leaderboards' : '/home/seller/leaderboards';
      items.push({ label: 'home.viewLeaderboards', routerLink: leaderboardRoute, icon: 'leaderboard' });
      items.push({ label: 'footer.support', routerLink: '/support', icon: 'help_outline' });

      this.mainNavConfig = { items };
      return;
    }

    this.mainNavConfig = { items: [] };
  }

  getUserPreferences(id: number) {
    const params = {
      userId: this.userProfile.id,
      preferenceId: id
    };
    this.managerService.getUserPreferences(params).subscribe((data: any) => {
      if (id === 6) {
        this.isSalesChallengeUser = data.enabled;
      }
      if (id === 7) {
        this.isActivityChallengeUser = data.enabled;
      }
      this.buildNavConfig();
    }, (err: any) => {
      this.errors = err;
    });
  }
}
